/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-11 15:53:00
 * @FilePath: \frontend\src\router\index.js
 */
import { createRouter, createWebHashHistory } from 'vue-router';
import { routeControlBefore } from '@/permission';
import { routeControlAfter } from '@/permission';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
  },
  // {
  //   path: '/oss',
  //   component: () => import('@/views/system/oss.vue'),
  //   hidden: true,
  // },
  {
    path: '/404',
    component: () => import('@/views/404.vue'),
    hidden: true,
  },
  {
    path: '/401',
    component: () => import('@/views/401.vue'),
    hidden: true,
  },
];

// const createRouter = () =>
//   new Router({
//     // mode: 'history', // require service support
//     scrollBehavior: () => ({
//       y: 0,
//     }),
//     mode: 'hash',
//     routes: constantRoutes,
//   });

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
  scrollBehavior: () => ({
    top: 0,
  }),
});

router.beforeEach(routeControlBefore);
router.afterEach(routeControlAfter);

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// export function resetRouter() {
//   const newRouter = createRouter();
//   router.matcher = newRouter.matcher; // reset router
// }

// Vue Router 3 -> Vue Router 4
// Detail see: https://qiita.com/hasesiu/items/f0d7e65418af25d29ead
export function resetRouter() {
  router.clearRoutes();
  addRoutes(constantRoutes);
}

export function addRoutes(routes) {
  routes.forEach((route) => {
    router.addRoute(route);
  });
}

export default router;
